module.exports = __webpack_public_path__ + "static/media/door0102.666c7240.jpg";